import cn from 'utils/cn'
import Icon from 'core/components/icons/Icon'
import useClipboard from 'core/hooks/utils/useClipboard'

interface Props {
  text:
    | 'Bank name'
    | 'Address'
    | 'ABA / Routing number'
    | 'Account number'
    | 'Account owner'
  value: string
  isCopyable?: boolean
  className?: string
}

const BankInfoRow = ({ text, value, isCopyable, className }: Props) => {
  const copyToClipboard = useClipboard()

  return (
    <div className={cn('grid grid-cols-[40%_1fr] mb-5 last:mb-0', className)}>
      <div className="subtitle-2">{text}</div>
      {value && (
        <div>
          <div
            className={cn(
              'w-[200px] text-dark flex',
              text === 'Address' ? 'items-start' : 'items-center',
              isCopyable ? 'cursor-pointer' : ''
            )}
            onClick={isCopyable ? () => copyToClipboard(value) : undefined}
          >
            {value}
            {isCopyable && (
              <Icon
                name="sheets-outline"
                size={18}
                color="text-dark-4"
                className="ml-1"
              />
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default BankInfoRow
